// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles_messageContainer__2VlH6"};